import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import ReturnsApi from '../../../API/shipment/returns-api';
import { NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1 } from '../../../components/Basic/WrapsStyle';
import { SHIPMENT_STATUS_TEXT, STATUS_COLORS, TO_REALIZATION, TO_RETURNS_REPORT, TYPE_BUTTONS } from '../../../constans';
import { getDate, numberWithSpaces } from '../../../utils';
import DeleteReturnReportPopUp from './DeleteReturnReportPopUp';
import styles from './styles.module.scss';
import { Select } from '../../../components/Basic/Inputs';

const width = ['40px', '140px', '150px', '200px'];

function ReturnsReportsPage() {
  const [create, setCreate] = useState(false);
  const [popUpDelete, setDeletePopUp] = useState({ show: false, realization: {} });

  const [count, setCount] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [show, setShow] = useState(50);

  const [data, setData] = useState([]);
  const [realizationsSelect, setRealizationsSelect] = useState({});
  const user = useSelector((store) => store.user);

  const onClickCreate = () => {
    setCreate(true);
  };

  const changeRealizationSelect = (number) => {
    if (realizationsSelect[number]) {
      const s = realizationsSelect;
      delete s[number];
      setRealizationsSelect({ ...s });
    } else {
      setRealizationsSelect({ ...realizationsSelect, [number]: true });
    }
    //setPostingsPrint({ ...postingsPrint, [order_number]: !postingsPrint[order_number] });
  };

  const openManyRealizations = () => { };
  const load = () => {
    ReturnsApi.getReportReturns({ data: { limit: parseInt(show) } }).then((r) => setData(r.reportReturns)); // FILTER[tab], - параметр статус
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const onCloseDelete = () => {
    setDeletePopUp({ show: false, realization: {} });
    load();
  };

  useEffect(() => {
    load();
  }, [tab, show]);

  const realizations_ids = Object.keys(realizationsSelect);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  console.log(data);
  return (
    <>
      <Content>
        <H1>Отчеты по возвратам</H1>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={['Все отчеты']}
              num={count}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
          </Row>
          <Row spaceBetween={true} style={{ marginTop: '25px' }}>
            <Row style={{ height: '40px' }}>
              <div>
                <Select
                  label="Показать на странице"
                  select={show}
                  list={['10', '20', '50', '100', '150', '200', '500', '1000']}
                  onSelect={(v) => setShow(v)}
                  width="150px"
                  style={{ marginRight: '15px' }}
                />
              </div>

              {realizations_ids.length > 1 && realizations_ids.length <= 6 && (
                <a href={TO_REALIZATION(realizations_ids.join('&'))} target={'_blank'} style={{ marginLeft: '10px' }}>
                  <Button type={TYPE_BUTTONS.BLUE} onClick={openManyRealizations}>
                    Открыть совместную реализацию
                  </Button>
                </a>
              )}
            </Row>
            {/*  <Column className={styles.column_button}></Column>*/}
          </Row>
        </WhiteBlock>
        <Table>
          <TableHeader whiteHeader>
            <HeaderTitle width={width[0]} />
            <HeaderTitle width={width[0]}>Id</HeaderTitle>
            <HeaderTitle width={width[2]} centerText>Дата возврата
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Количество возвратов
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Статус
            </HeaderTitle>
            <HeaderTitle width={width[3]} centerText>
              Создатель
            </HeaderTitle>
          </TableHeader>
          {(data || []).map((item) => {
            return (
              <TableLine key={item.id}>
                <TableCell width={width[0]}>
                  <CheckButton
                    checked={realizationsSelect[item.id]}
                    onSelect={() => changeRealizationSelect(item.id)}
                  //disabled={is_disabled_print}
                  />
                </TableCell>
                <TableCell width={width[0]}>{item.id}</TableCell>

                <TableCell width={width[2]} center>
                  <NavLink to={TO_RETURNS_REPORT(item.id)} className={styles.line_table_link}>
                    {getDate(item.date_report_return)}
                  </NavLink>
                </TableCell>
                <TableCell width={width[2]} center>
                  {numberWithSpaces(item.count) || 0}
                </TableCell>
                <TableCell width={width[2]} style={{ color: `${STATUS_COLORS[item.state]}` }} center>
                  {SHIPMENT_STATUS_TEXT[item.state]}
                </TableCell>
                <TableCell width={width[3]} center>
                  Система
                </TableCell>
              </TableLine>
            );
          })}
        </Table>
      </Content>
      {popUpDelete.show && <DeleteReturnReportPopUp shipment={popUpDelete.realization} close={onCloseDelete} />}
    </>
  );
}

export default ReturnsReportsPage;
